var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEmpty, isNil, keys } from "ramda";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import InputField from "../common/InputField";
var validate = function (order) {
    var errors = {};
    if (isEmpty(order.product) || isNil(order.product)) {
        if (order.locations <= 0) {
            errors.locations = "Locations must be set since no product was chosen";
        }
        if (order.monthly.amount <= 0) {
            errors.monthly = "Monthly price must be set since no product was chosen";
        }
    }
    return errors;
};
var WizardFormThirdPage = function (props) {
    var previousPage = props.previousPage, submit = props.submit;
    var _a = useState(props.order), order = _a[0], setOrder = _a[1];
    var errors = validate(order);
    return (React.createElement("form", { className: "order__form_step", onSubmit: function (e) { return e.preventDefault(); } },
        React.createElement("p", null, "(Leave empty if not needed.)"),
        React.createElement("br", null),
        React.createElement("div", null,
            React.createElement(InputField, { type: "number", label: "Locations", placeholder: "Amount of devices", value: order.locations, onChange: function (locations) { return setOrder(__assign(__assign({}, order), { locations: parseInt(locations, 10) })); }, meta: { touched: true, error: errors.locations } }),
            React.createElement(InputField, { type: "number", label: "Price", placeholder: "Monthly", value: order.monthly.amount, onChange: function (price) {
                    return setOrder(__assign(__assign({}, order), { monthly: __assign(__assign({}, order.monthly), { amount: parseInt(price, 10) }) }));
                }, meta: { touched: true, error: errors.monthly } }),
            React.createElement(InputField, { type: "number", label: "Fee", placeholder: "Once", value: order.fee.amount, onChange: function (fee) { return setOrder(__assign(__assign({}, order), { fee: __assign(__assign({}, order.fee), { amount: parseInt(fee, 10) }) })); } }),
            React.createElement(InputField, { type: "number", label: "Videos", placeholder: "How many videos", value: order.videos, onChange: function (videos) { return setOrder(__assign(__assign({}, order), { videos: parseInt(videos, 10) })); } })),
        React.createElement("div", null,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { type: "button", className: "previous white btn-flat left red-text", onClick: function () { return previousPage(order); } }, "Previous"),
            React.createElement("button", { type: "submit", className: "right teal btn-flat btn white-text", disabled: keys(errors).length > 0, onClick: function () { return submit(order); } }, "Submit"),
            React.createElement(Link, { to: "/orders", className: "right white btn-flat left red-text" }, "Cancel"))));
};
export default WizardFormThirdPage;



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderFormThirdStep.tsx
// module id = 1239
// module chunks = 0